export default __webpack_public_path__ + "static/favicon-15a807c2c5258d8b02667c601d880d5d.svg";